var _path, _path2, _path3, _path4, _path5, _line, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup48095705(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 112,
    viewBox: "0 0 101 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.25 41.6911L25.75 13.1461",
    stroke: "#DA291C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100 77.9887V33.9887C99.998 32.0597 99.4888 30.1652 98.5235 28.4951C97.5581 26.8251 96.1706 25.4382 94.5 24.4737L56 2.47372C54.3278 1.50827 52.4309 1 50.5 1C48.5691 1 46.6722 1.50827 45 2.47372L6.5 24.4737C4.82944 25.4382 3.44189 26.8251 2.47654 28.4951C1.51119 30.1652 1.00198 32.0597 1 33.9887V77.9887C1.00198 79.9177 1.51119 81.8123 2.47654 83.4823C3.44189 85.1524 4.82944 86.5392 6.5 87.5037L45 109.504C46.6722 110.469 48.5691 110.977 50.5 110.977C52.4309 110.977 54.3278 110.469 56 109.504L94.5 87.5037C96.1706 86.5392 97.5581 85.1524 98.5235 83.4823C99.4888 81.8123 99.998 79.9177 100 77.9887Z",
    stroke: "#DA291C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48828 28.2687L50.5033 56.0437L98.5183 28.2687",
    stroke: "#DA291C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 109.73V55.9903",
    stroke: "#DA291C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1992 92.1303L72.5 88.5L77.5 85.5L81 84L84.5992 83.3303",
    stroke: "#DA291C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 67.5,
    y1: 72.8303,
    x2: 67.5,
    y2: 78.4303,
    stroke: "#DA291C",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 82.8984,
    y1: 64.0303,
    x2: 82.8984,
    y2: 69.6303,
    stroke: "#DA291C",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup48095705);
export default __webpack_public_path__ + "static/media/Group 48095705.2b9802023a7ece749460b2a5a99aeb08.svg";
export { ForwardRef as ReactComponent };